<style>
  .round-button {
  margin-right: 8px;
  font-weight: bold;


}

.green {
background-color: #7ed47c;
border: 1px solid #0E990B !important;
color: #037c03;
}

.red {
background-color: #ffaab4;
border: 1px solid #DD011D !important;
color: #ff0000;
}

.yellow {
background: rgb(186, 230, 255) !important;
border: 1px solid rgb(23, 95, 135) !important;
color: rgb(23, 95, 135) !important;
}

.form-control {
padding-left: 10px !important;
color: black;
}

.btn.btn-rounded {
border-radius: 50px;
}

.attendance-report-table-body {
background: white;
display: flex;
align-items: center;
border-bottom: 1px solid #F5F5F5;
/* border-top: 1px solid #F5F5F5; */
}

.dark-backround {
background: #171C31 !important;
background-color: #171C31 !important;
color: white;
}

.table-cotent {
width: 20%;
}

.table-content-heading {
display: none;
}

.table-content-heading h1 {
font-size: 1rem;
margin-bottom: 0px;
}

.table-cotent:nth-of-type(1) .table-content-value {
display: flex;
}

.table-cotent:nth-of-type(1) .table-content-value h1:nth-of-type(1)::after {
content: ', ';
}

.table-cotent:nth-of-type(1) .table-content-value h1:nth-of-type(1) {
font-size: 1rem;
padding-right: 2px;
}

.table-content-value h1 {
font-size: 1rem;
margin-bottom: 0px;
}

.table-cotent:nth-of-type(5) .table-content-value {
display: flex;
justify-content: center;
}

.table-cotent:nth-of-type(5) .table-content-value h1 {
border-radius: 20px;
font-size: 0.6rem;
padding: 5px 8px;
margin: 0px 2px;
}

@media only screen and (max-width: 767px) {
.table-cotent:nth-of-type(5) .table-content-value h1:nth-of-type(1) {
margin-left: 0px;
}

.table-cotent:nth-of-type(5) .table-content-value {
display: flex;
justify-content: start;
}

.attendance-report-table-body {
flex-direction: column;
border-radius: 15px;
box-shadow: 0 10px 10px -5px;
}

.table-content-heading {
display: block;
width: 50%;
}

.table-content-value {
width: 50%;
}

.table-cotent {
display: flex;
justify-content: space-around;
width: 100%;
}

.table-cotent:nth-of-type(1) .table-content-value {
display: flex;
}

.table-cotent:nth-of-type(1) .table-content-value h1:nth-of-type(1) {
font-size: 1rem;
padding-right: 0.3rem;
}
}

@media only screen and (max-width:576px) {
.table-cotent:nth-of-type(5) .table-content-value {
display: flex;
flex-direction: column;
justify-content: start;
align-items: flex-start;
}

.table-cotent:nth-of-type(5) .table-content-value h1 {
margin: 5px 0px;
}
}

@media only screen and (max-width:396px) {

.table-content-value h1,
.table-content-heading h1 {
font-size: 0.8rem !important;
}
}
</style>
<div class="attendance-report-table-body d-flex justify-content-around px-3 my-4 my-md-0 py-4"
  [ngClass]="{ 'dark-backround': selectedMode === 'dark' }" style="background: {{backgroundColor}} !important; ">
  <div class="table-cotent">
    <div class="table-content-heading">
      <h1>Date</h1>
    </div>
    <div class="table-content-value">
      @if (type.data && type.data.length > 0) {
        <h1>{{ type.data[0].date | date: "EEEE" }}</h1>
      }
      @if (type.data && type.data.length > 0) {
        <h1> {{ type.data[0].date | date: "dd MMM " }}</h1>
      }
    </div>
  </div>
  <div class="table-cotent">
    <div class="table-content-heading">
      <h1>Check In</h1>
    </div>

    @for (obj of type.data; track obj) {
      <div class="table-content-value text-center" id="checkin-value">
        <h1 style="color:{{titleColor}} !important;"> {{ checkin ==='' || checkin == null ? "-":obj.check_in }}</h1>
      </div>
    }
  </div>
  <div class="table-cotent">
    <div class="table-content-heading">
      <h1>Check Out</h1>
    </div>
    @for (obj of type.data; track obj) {
      <div class="table-content-value text-center" id="checkout-value">
        <h1 style="color:{{titleColortwo}} !important;"> {{ checkout === '' || checkout == null ?"-":obj.check_out }}</h1>
      </div>
    }
  </div>

  <div class="table-cotent">
    <div class="table-content-heading">
      <h1>Working Hours</h1>
    </div>
    <div class="table-content-value text-center">

      <h1 id="wh" style="color:{{titleColorthree}} !important;">{{
        workingHours == null || workingHours === "" ? "-" : workingHours == 0 ? "-" : workingHours == 7 ? "7.00" :
        workingHours == 9 ? "9.00": workingHours == 10 ? "10.00" : workingHours
      }}</h1>
      @if (isOverTime()) {
        <h1 id="wh" style="color:#c70085 !important;">+{{ type.data[0].overtime}}x</h1>
      }
    </div>

  </div>
  <div class="table-cotent">
    <div class="table-content-heading ">
      <h1>Status</h1>
    </div>
    <div class="table-content-value text-center">
      @for (item of attendanceType; track item) {
        <h1
          style="color:{{item.color}}!important;border:{{item.bdrcolor}} !important; background:{{item.bgcolortitle}}!important;font-size:{{item.fontsize}}!important;"
        class=" mb-0"> {{ item.title }}</h1>
      }
    </div>
  </div>
  <div class="table-cotent">
    <div class="table-content-heading ">
      <h1>plus btn</h1>
    </div>
    <div class="table-content-value text-center">

      @if (status === 'pending' || status === 'approved' || status === 'rejected') {
        <button type="button" (click)="btnok(id)"
        class="btn btn-primary btn-rounded btn-icon round-button" [ngClass]="{
        'green': status === 'approved',
        'yellow': status === 'pending',
        'red': status === 'rejected'
        }"> <i aria-hidden="true"> {{noOfRequest}}</i> </button>
        }
        <button type="button" [routerLink]="'/attendance-correction-request'" (click)="sendDataToReceiver()"
          class="btn btn-primary btn-rounded btn-icon ">
          <i class="fa fa-plus" aria-hidden="true"> </i>
        </button>

      </div>
    </div>
  </div>